(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function HeaderSubMenu(elem) {
        Behaviors.init(HeaderSubMenu, this, arguments);

        var $thisElem = this.$elem;

        // Open Positions Dropdown
        $thisElem.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(this).parent().hasClass('HeaderSubMenu-nav_dropdown--open')) {
                $thisElem.parent().removeClass('HeaderSubMenu-nav_dropdown--open');
            } else {
                $thisElem.parent().removeClass('HeaderSubMenu-nav_dropdown--open');
                $(this).parent().addClass('HeaderSubMenu-nav_dropdown--open');
            }
        });

        $(document).on('click', function() {
            $thisElem.parent().removeClass('HeaderSubMenu-nav_dropdown--open');
        });
    }

    Behaviors.inherit(HeaderSubMenu, Behaviors.Behavior);

    HeaderSubMenu.QUERY = "[data-resources-nav]";

    Behaviors.register_behavior(HeaderSubMenu);

    module.HeaderSubMenu = HeaderSubMenu;

    return module;

}(window.jQuery, window.Behaviors));